import { observer } from 'mobx-react-lite';
import { Box } from '@cad-arc';
import { useEsriMapStore } from '../../hooks/use-esri-map-store';
import { UnitPanel } from './unit-panel/unit-panel';
import { EventPanel } from './event-panel/event-panel';
import { PhoneCallPanel } from './phone-call-panel/phone-call-panel';
import { AmlCallPanel } from './aml-call-panel/aml-call-panel';
import { StationPanel } from './station-panel/station-panel';
import { HospitalPanel } from './hospital-panel/hospital-panel';
import { LocationPanel } from './location-panel/location-panel';
import { EsriMapEntityTypeEnum } from '../../../esri/types';

export const MapEntityDetails = observer(function MapEntityDetails(): React.ReactElement {
    const {
        locationSearchSelectedGeoPointLocation: geoPointLocation,
        geoPointAddressForLocationSearch,
        selectedUnitId,
        selectedUnitUserId,
        selectedPhoneCallId,
        selectedEventId,
        selectedAmlPhoneNumberId,
        selectedStationId,
        selectedHospitalId,
        selectedMapLedgerEntityType,
    } = useEsriMapStore();

    const isLocationPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.GEO_POINT_LOCATION &&
        (geoPointAddressForLocationSearch || geoPointLocation);
    const isUnitPanelShown =
        (selectedMapLedgerEntityType === EsriMapEntityTypeEnum.UNIT && selectedUnitId) ||
        (selectedMapLedgerEntityType === EsriMapEntityTypeEnum.USER && selectedUnitUserId);
    const isEventPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.EVENT && selectedEventId;
    const isPhoneCallPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.PHONE_CALL && selectedPhoneCallId;
    const isAmlCallPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.AML_CALL && selectedAmlPhoneNumberId;
    const isStationPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.STATION && selectedStationId;
    const isHospitalPanelShown =
        selectedMapLedgerEntityType === EsriMapEntityTypeEnum.HOSPITAL && selectedHospitalId;

    return (
        <Box width="100%">
            {isLocationPanelShown && <LocationPanel />}
            {isUnitPanelShown && <UnitPanel />}
            {isEventPanelShown && <EventPanel />}
            {isPhoneCallPanelShown && <PhoneCallPanel />}
            {isAmlCallPanelShown && <AmlCallPanel />}
            {isStationPanelShown && <StationPanel />}
            {isHospitalPanelShown && <HospitalPanel />}
        </Box>
    );
});
